<template>
	<div class="CollLogin">
		<div class="collLogin_body">
			<iframe :src="vrUrl" width="100%" height="100%"></iframe>
			<div class="store_box">
				<el-row type="flex" align="middle" justify="space-between" class="store_top">
					<el-row type="flex" align="middle">
						<img class="store_top_icon" src="@/assets/img/shop.png" />
						<div class="store_top_text">全国服务网点</div>
					</el-row>
					<div @click="putStore" class="store_top_btn">
						<img class="store_top_put" :class="{'store_top_put1': putStatus}" src="@/assets/img/put.png" />
					</div>
				</el-row>
				<div class="store_main" :class="{'store_main1': putStatus}">
					<el-row type="flex" class="store_item" v-for="(item,index) in stores" :key="index">
						<img class="store_icon" src="@/assets/img/location.png" />
						<div class="store_content">
							<div class="store_name text_hidden">{{item.name}}</div>
							<div class="store_text text_hidden">{{item.describe}}</div>
							<div class="store_text text_hidden">地址：{{item.province_text}}{{item.city_text}}{{item.area_text}}{{item.address}}</div>
						</div>
					</el-row>
				</div>
			</div>
			<div class="login_box" :class="{'login_box1': putStatus}">
				<div class="login_content">
					<el-form :model="collForm" ref='collForm'>
						<el-row type="flex" justify="center" class="login_t">
							<img class="login_logo" src="@/assets/maitu-logo.svg" />
						</el-row>
						<el-form-item prop="order_number" :rules="[{ required: true, message: '单号不能为空'}]">
							<el-row type="flex" align="middle" class="login_input">
								<div class="input_title">单号</div>
								<el-input readonly class="input_content" :clearable="clearable" v-model="collForm.order_number" placeholder="请输入"></el-input>
							</el-row>
						</el-form-item>
						<el-row type="flex" justify="center" class="login_b">
							<el-button type="success" class="login_btn" @click="submitForm('collForm')">登录</el-button>
						</el-row>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CollLogin',
		data() {
			return {
				putStatus: !1,
				clearable: !0,
				collStatus: !1,
				collForm: {
					order_number: '',
					isColl: 1
				},
				stores: [],
				vrUrl: ""
			}
		},
		created() {
			this.reload();
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
		},
		methods: {
			reload() {
				let that = this;
				sessionStorage.setItem("token",that.$route.query.token);
				that.getIndex(),that.getStore();
			},
			getIndex(){
				let that = this;
				that.$fetch('addons/hlm/api.Index/getOrderNum', {isColl: 1}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.vrUrl = res.data.vr,that.collForm.order_number = res.data.order_number;
					}else{
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getStore(){
				let that = this;
				that.$fetch('addons/hlm/api.index/shopList', {isColl: 1,page: 1}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.stores = res.data.list;
					}else{
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			// 店铺收缩
			putStore(){
				let that = this;
				that.putStatus = !that.putStatus;
			},
			submitForm(collForm) {
				let that = this
				if (that.collStatus) return
				that.$refs[collForm].validate((valid) => {
					if (valid) {
						that.collStatus = !0
						that.$fetch('addons/hlm/api.Cooperation/logon', that.collForm).then(function(res) {
							console.log(res)
							if (res.code == 1) {
								sessionStorage.setItem('order_number', that.collForm.order_number)
								that.$message({
									message: '登录成功',
									type: 'success',
									duration: 1500,
									center: !0,
									onClose() {
										that.collStatus = !1, that.$router.push("/collEdit")
									}
								});
							}else{
								that.collStatus = !1
							}
						}).catch(function(error) {
							console.log(error)
							that.collStatus = !1
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
		}
	};
</script>
<style>
	::-webkit-scrollbar {
		width: 0px;
		height: 0px;
	}
	.CollLogin .collLogin_body{
		width: 100%;
		height: 100vh;
		overflow: hidden;
	}
	.CollLogin .store_box{
		width: 400px;
		position: fixed;
		top: 100px;
		left: 18px;
		z-index: 10;
	}
	.CollLogin .store_top{
		height: 50px;
		background-color: #00B950;
		padding: 0 16px;
	}
	.CollLogin .store_top_icon{
		width: 20px;
		height: 20px;
		margin-right: 14px;
	}
	.CollLogin .store_top_text{
		font-size: 18px;
		font-weight: bold;
		color: #FFFFFF;
	}
	.CollLogin .store_top_btn{
		width: 50px;
		height: 50px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		cursor: pointer;
	}
	.CollLogin .store_top_put{
		width: 22px;
		height: 19px;
		transition: all 0.5s;
	}
	.CollLogin .store_top_put1{
		transform: rotate(180deg);
	}
	.CollLogin .store_main{
		padding: 0 16px;
		background-color: rgba(255,255,255,0.6);
		height: 720px;
		overflow-y: scroll;
		cursor: pointer;
		transition: all 0.5s;
	}
	.CollLogin .store_main1{
		height: 0!important;
	}
	.CollLogin .store_main::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}
	
	.CollLogin .store_main::-webkit-scrollbar-thumb {
		border-radius: 5px;
		background-color: #999999;
	}
	
	.CollLogin .store_main::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #ededed;
		border-radius: 5px;
	}
	.CollLogin .store_icon{
		width: 20px;
		height: 20px;
		margin-top: 17px;
		margin-right: 8px;
	}
	.CollLogin .store_content{
		width: 340px;
		padding: 15px 0;
		border-bottom: 1px solid #D1D1D1;
	}
	.CollLogin .store_name{
		font-size: 15px;
		font-weight: 500;
		line-height: 25px;
		color: #333333;
		width: 100%;
		height: 25px;
	}
	.CollLogin .store_text{
		font-size: 13px;
		line-height: 23px;
		color: #666666;
		width: 100%;
		height: 23px;
	}
	
	.CollLogin .login_box{
		width: 500px;
		height: 310px;
		background: rgba(0, 0, 0, 0.5);
		border-radius: 8px;
		backdrop-filter: blur(4px);
		position: fixed;
		top: 50%;
		left: 50%;
		margin-top: -155px;
		margin-left: -250px;
		z-index: 10;
		transition: all 0.5s;
		overflow: hidden;
	}
	.CollLogin .login_box1{
		height: 0;
	}
	.CollLogin .login_content{
		width: 100%;
		height: 100%;
		padding: 30px;
	}
	.CollLogin .login_t{
		padding: 10px 0 40px;
	}
	.CollLogin .login_logo{
		width: 180px;
		height: 70px;
		object-fit: contain;
		object-position: left center;
	}
	.CollLogin .input_title{
		font-size: 18px;
		color: #FFFFFF;
		font-weight: 500;
		width: 66px;
		text-align: right;
		padding-right: 20px;
	}
	.CollLogin .input_content input{
		width: 380px;
		height: 50px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #E5E5E5;
		padding: 0 20px;
		font-size: 18px;
		color: #666666;
		font-weight: 500;
	}
	.CollLogin .login_b{
		padding: 10px 0 0;
	}
	.CollLogin .login_btn{
		width: 160px;
		background: #00B950;
		border-radius: 4px;
	}
</style>
